import {ContentProductListParam} from '../../common/shared/api/nicolas/params/ContentProductListParam.interface';
import {ContentProductListResultVo} from '../../common/shared/api/nicolas/vo/ContentProductListResultVo.interface';
import {SingleListConnection} from '../generated/types';
import {createPageInfo} from './PageInfo';
import {createSingleListViewItem} from './SingleListViewItem';
import {createSortOption} from './SortOption';

export function createSingleListConnection({
  params: {cursor_index, cursor_direction},
  result: {
    list,
    total_count,
    sort_opt_list,
    selected_sort_opt,
    has_prev,
    has_next,
    series_item,
  },
}: {
  params: ContentProductListParam;
  result: ContentProductListResultVo;
}): SingleListConnection {
  return {
    totalCount: total_count,
    selectedSortOption: createSortOption({sortOptVo: selected_sort_opt}),
    sortOptionList: sort_opt_list.map(sortOpt =>
      createSortOption({sortOptVo: sortOpt})
    ),
    pageInfo: createPageInfo({
      hasPreviousPage: !!has_prev,
      hasNextPage: !!has_next,
      startCursor:
        list && list.length > 0 ? String(list[0].cursor_index) : undefined,
      endCursor:
        list && list.length > 0
          ? String(list[list.length - 1].cursor_index)
          : undefined,
    }),
    edges: list.map(vo => {
      return {
        cursor: String(vo.cursor_index),
        node: createSingleListViewItem({
          contentHomeItemSingleDto: vo.item,
          itemSeriesDto: series_item,
        }),
      };
    }),
  };
}
